import { QuestionBase } from './question-base';

const BASE_TOOLBAR_ITEMS = ['undo', 'redo', 'bold', 'italic', 'underline', { list: 'ordered' }, { list: 'bullet' }];
/*
Sample:

new WysiwygQuestion({
  key: 'objectives',
  label: 'course.meta.objectives',
  class: 'col s12'
  value: '<p>Learn.</p>,
  order: 1
}),
*/
export class WysiwygQuestion extends QuestionBase<string> {
  controlType = 'wysiwyg';
  type: string;
  toolbarItems: any[];

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.heightBox = options['heightBox'] || 256;
    this.type = options['type'] || 'text';
    this.toolbarItems = options['toolbarItems'] || BASE_TOOLBAR_ITEMS;
  }
}
